<script>
    export let fill = '#fff'
</script>

<style>
    svg#schedule-highlight-label-text {
        position: absolute;
        width: 306.2px;
        height: 166.19px;
        top: 225px;
        left: 25px;
    }

    .cls-1 {
        font-size: 13px;
        fill: #fff;
        font-family: AvenirNext-Regular, Avenir Next;
    }
    .cls-2 {
        letter-spacing: -0.01em;
    }
    .cls-3 {
        letter-spacing: -0.01em;
    }
    .cls-4 {
        letter-spacing: 0em;
    }
    .cls-5 {
        letter-spacing: -0.05em;
    }
    .cls-6 {
        letter-spacing: -0.02em;
    }
</style>

<svg id="schedule-highlight-label-text" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 306.2 166.19">
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <text class="cls-1" transform="translate(0 11.1)">
                N
                <tspan class="cls-2" x="9.93" y="0">e</tspan>
                <tspan x="17.29" y="0">xt</tspan>
                <tspan class="cls-3" x="30.95" y="0">E</tspan>
                <tspan class="cls-4" x="38.49" y="0">vent</tspan>
            </text>
            <text class="cls-1" transform="translate(154.17 160.85)">
                <tspan class="cls-5">P</tspan>
                <tspan class="cls-6" x="6.92" y="0">r</tspan>
                <tspan x="11.36" y="0">esented By: McDonalds</tspan>
            </text>
        </g>
    </g>
</svg>
